// src/types/profile.ts
// FIXES:
// - Add push_enabled to Profile interface
// - Export SKILL_LEVELS constant
// - Add pronouns field to Profile interface
// - Add is_admin field to Profile interface

export interface Profile {
  id: string;
  username: string;
  display_name?: string;
  pronouns?: string | null;
  bio?: string;
  avatar_url?: string | null;
  avatar?: any;
  is_admin?: boolean;
  is_early_adopter?: boolean; // Early adopter badge
  location_city?: string;
  location_state?: string;
  location_country?: string;
  location_lat?: number;
  location_lng?: number;
  location_name?: string;
  max_distance_km?: number;
  gender?: string[] | null;
  genders?: string[] | null;
  gender_preference?: string[] | null;
  play_preferences?: string[] | null;
  online_platforms?: string[] | null;
  push_enabled?: boolean | null; // Push notification preference
  apns_token?: string | null; // Apple Push Notification Service token
  fcm_token?: string | null; // Firebase Cloud Messaging token
  created_at?: string;
  updated_at?: string;
}

export interface UserGame {
  id: string;
  user_id: string;
  game_id: string;
  skill_level?: string;
  favorite: boolean;
  created_at: string;
  game?: Game;
}

export interface Game {
  id: string;
  name: string;
  short_name?: string;
  bgg_id?: number;
  image_url?: string | null;
  min_players?: number;
  max_players?: number;
  year_published?: number;
  game_type?: string;
  is_system?: boolean;
  created_at?: string;
}

export interface Availability {
  id?: string;
  user_id?: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  created_at?: string;
}

export const DAYS_OF_WEEK = [
  { value: 0, name: 'Sunday' },
  { value: 1, name: 'Monday' },
  { value: 2, name: 'Tuesday' },
  { value: 3, name: 'Wednesday' },
  { value: 4, name: 'Thursday' },
  { value: 5, name: 'Friday' },
  { value: 6, name: 'Saturday' },
];

export const GENDER_OPTIONS = [
  { value: 'man', label: 'Man' },
  { value: 'woman', label: 'Woman' },
  { value: 'non-binary', label: 'Non-binary' },
  { value: 'other', label: 'Other' },
];

export const PLAY_PREFERENCE_OPTIONS = [
  { value: 'in-person', label: 'In-Person' },
  { value: 'online', label: 'Online' },
];

export const ONLINE_PLATFORM_OPTIONS = [
  { value: 'tabletop-simulator', label: 'Tabletop Simulator' },
  { value: 'board-game-arena', label: 'Board Game Arena' },
  { value: 'tabletopia', label: 'Tabletopia' },
  { value: 'yucata', label: 'Yucata' },
  { value: 'boiteajeux', label: 'BoÃ®te Ã  Jeux' },
  { value: 'other', label: 'Other' },
];

// FIX: Export SKILL_LEVELS constant
export const SKILL_LEVELS = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'expert', label: 'Expert' },
] as const;

export type SkillLevel = typeof SKILL_LEVELS[number]['value'];